module.exports = __webpack_public_path__ + "img/3.f5c41913.png";